import React, { FC } from "react";
import { TableCell as MuiTableCell } from "@mui/material";

type Props = React.ComponentProps<typeof MuiTableCell>;

const TableCell: FC<Props> = (props) => {
    return <MuiTableCell {...props}/>
}

export default TableCell;